export const FIELD_TITLE = "fields.title";
export const FIELD_ARTICLE_TYPE = "fields.articleType";
export const FIELD_LEAD = "fields.lead";
export const FIELD_SLUG = "fields.slug";
export const FIELD_THUMBNAIL = "fields.thumbnail";
export const FIELD_PUBLISH_DATETIME = "fields.publishDateTime";
export const FIELD_PUBLISH_STATUS = "fields.publishStatus";
export const FIELD_RELEASE_DATE = "fields.releaseDate";
export const FIELD_FEATURED_POST = "fields.featuredPost";
export const FIELD_EVENT_TYPE = "fields.eventType";
export const FIELD_EVENT_STATUS = "fields.eventStatus";
export const FIELD_SHOW_ON_CUSTOMERS = "fields.showOnCustomers";
export const FIELD_IS_TUTORIAL = "fields.isTutorial";
export const FIELD_INTERNAL_SLUG = "fields.internalSlug";
export const SYS_CONTENT_TYPE = "sys.contentType";
